/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { AccessRole } from './AccessRole';
import {
    AccessRoleFromJSON,
    AccessRoleFromJSONTyped,
    AccessRoleToJSON,
    AccessRoleToJSONTyped,
} from './AccessRole';

/**
 * 
 * @export
 * @interface ListAccessRolesResponse
 */
export interface ListAccessRolesResponse {
    /**
     * 
     * @type {Array<AccessRole>}
     * @memberof ListAccessRolesResponse
     */
    data: Array<AccessRole>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListAccessRolesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListAccessRolesResponse interface.
 */
export function instanceOfListAccessRolesResponse(value: object): value is ListAccessRolesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListAccessRolesResponseFromJSON(json: any): ListAccessRolesResponse {
    return ListAccessRolesResponseFromJSONTyped(json, false);
}

export function ListAccessRolesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAccessRolesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AccessRoleFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListAccessRolesResponseToJSON(json: any): ListAccessRolesResponse {
      return ListAccessRolesResponseToJSONTyped(json, false);
  }

  export function ListAccessRolesResponseToJSONTyped(value?: ListAccessRolesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AccessRoleToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

